import { IPerson } from '../../assessment-management.models';

export enum CascadingFocusPanelIds {
  SelectSkills = 'SelectSkills',
  ImportSkills = 'ImportSkills',
}

export enum ErrorMessage {
  NoSkills = 'No skills selected',
  ManagerReviewSkills = 'All selected non-managers must have at least one skill assigned.',
  PeerReviewSkills = 'All selected people must have at least one skill assigned.',
  SelfReviewSkills = 'All selected people must have at least one skill assigned.',
}

export interface ISkillsStepLayoutProps {
  assessmentSlug: string;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  people: IPerson[] | undefined;
  roleSlug: string | undefined;
  setPeople: (people: IPerson[]) => void;
  onBack: () => void;
  onNext: () => void;
}

